export default {
  short_description: 'Bespaar tijd & verdien beloningen!',
  full_description:
    'De {{name}} App is er – voor nog eenvoudiger bestellen:\n\n• Supersnel bestellen via app\n\n• Directe meldingen over acties en beloningen\n\n• Spaar en wissel uw punten eenvoudig in\n\n• Volg de status van uw bestelling in realtime\n\nWij bieden u graag onze app aan – en hopen dat u er net zoveel plezier aan beleeft als wij!`',
};
